import React from "react";

import { loadScript, random } from "../../../utils";
import { Game } from "../../models/Game";
import { AppInsightsAnalytics } from "../../services/AppInsight";
import "./RewardVideo.css";

type RewardVideoProps = {
  onEnd: () => void;
  game: Game;
};

export class RewardVideo extends React.Component<RewardVideoProps> {
  disposed: boolean = false;

  playerId = "yU930yHUp";
  account = "3772599298001";
  playerClassName = "vjs-fluid";

  initPlayer() {
    try {
      const playerContainer = document.querySelector(
        `video[data-player="${this.playerId}"]`
      );
      const player = (window as any).bc(playerContainer.id);

      let rnd = random(0, player.playlist.lastIndex());
      player.playlist.currentItem(rnd);
      player.muted(true);
      player.play();

      player.on(["error", "ended"], (event) => {
        if (this.disposed) {
          return;
        }
        this.disposed = true;

        player.pause();
        setTimeout(() => {
          player.dispose();
          this.props.onEnd();
        }, 200);
      });
    } catch (e) {
      console.error(e);
      AppInsightsAnalytics.trackAppError("brightcove init failed", {
        message: e.message,
        stack: e.stack || "",
      });
      this.props.onEnd();
    }
  }

  componentDidMount() {
    loadScript(
      `https://players.brightcove.net/${this.account}/${this.playerId}_default/index.min.js`
    ).then(() => setTimeout(() => this.initPlayer(), 1000));
  }

  render() {
    return (
      <React.Fragment>
        <Player>
          <video-js
            data-account={this.account}
            data-player={this.playerId}
            data-embed="default"
            controls=""
            data-application-id=""
            data-playlist-id="1708552017354415928"
            className={this.playerClassName}
            data-video-id=""
          />
        </Player>
      </React.Fragment>
    );
  }
}

const Player = (props: any) => (
  <div className="player-ark-aarp-container" children={props.children} />
);
